import axios from 'axios';

export default function pingPublicUser({ authToken }) {
  return axios
    .post(
      `${process.env.REACT_APP_API_URL}/public/ping`,
      {},
      {
        validateStatus: (status) => status === 200,
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      }
    )
    .then((result) => result.data.result.auth_token);
}
